import { MutableRefObject, useMemo } from 'react'
import { ListProps as ListComponentProps } from 'react-virtualized/dist/commonjs/List'

import List from './List'
import { useScroll } from 'utils/Hooks'
import { SimpleListProps } from './'
import { ListConfigType } from '../index'

type ListWithScrollProps<Item> = Pick<ListComponentProps, 'scrollTop' | 'width'> &
  Partial<Pick<ListComponentProps, 'onScroll'>> &
  Pick<
    SimpleListProps<Item>,
    'calculateCellHeight' | 'data' | 'debug' | 'noRowsRenderer' | 'renderItem' | 'scrollRef'
  > & {
    config: ListConfigType
    containerRef: MutableRefObject<HTMLDivElement | null>
    onBottom?: Function
    setRef?: any
  }

function ListWithScroll<Item>(props: ListWithScrollProps<Item>) {
  const {
    calculateCellHeight,
    config,
    containerRef,
    data,
    debug,
    noRowsRenderer,
    onBottom,
    onScroll,
    scrollRef,
    renderItem,
    width
  } = props

  const scrollConfig = useMemo(() => {
    return {
      ref: scrollRef as MutableRefObject<any>,
      onScroll:
        onScroll || onBottom
          ? (scrollTop: number, element: any, direction: string) => {
              const containerOffsetTop = containerRef?.current?.offsetTop || 0
              const scrollTopAdjusted = scrollTop - containerOffsetTop
              const scrollHeight =
                scrollRef !== window
                  ? (scrollRef as MutableRefObject<any>)?.current?.scrollHeight
                  : undefined

              onScroll?.({
                clientHeight: 0,
                clientWidth: 0,
                scrollHeight,
                scrollLeft: 0,
                scrollTop: scrollTopAdjusted >= 0 ? scrollTopAdjusted : 0,
                scrollWidth: width
              })

              if (
                containerRef?.current?.clientHeight &&
                onBottom &&
                scrollTop + window.innerHeight >= containerRef?.current?.clientHeight - 200 &&
                scrollTop + window.innerHeight <= containerRef?.current?.clientHeight + 200
              ) {
                onBottom?.()
              }
            }
          : undefined
    }
  }, [containerRef, onBottom, onScroll, scrollRef, width])

  useScroll(scrollConfig)

  return (
    <List
      calculateCellHeight={calculateCellHeight}
      debug={debug}
      config={config}
      data={data}
      noRowsRenderer={noRowsRenderer}
      onScroll={onScroll}
      renderItem={renderItem}
      width={width}
    />
  )
}

export default ListWithScroll
